import React, { useEffect, useState } from "react";
import { useMaterialUIController } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import MDTypography from "../../components/MDTypography";
import Footer from "../../examples/Footer";

import { Card, Box, Icon } from "@mui/material";
import MDButton from "../../components/MDButton";
import TextField from "@mui/material/TextField";
import { API_URL } from "../../constants/constants";


function HomeSectionEditor(props) {
  const [isAutoSlideEnabled, setIsAutoSlideEnabled] = useState(false);
  const [isRandomOrder, setIsRandomOrder] = useState(false);
  const [items, setItems] = useState([
    {
      id: 1,
      label: "섹션 1",
      expanded: true,
      data: {
        asset: { mobile: "", desktop: "" },
        title: { text: "", font_color: "#000000" },
        button: {
          background_color: "#000000",
          font_color: "#ffffff",
          text: "",
          is_outlined: false,
          outline_color: "#ffffff",
          link: ""
        },
        is_gradient_enabled: false,
        auto_slide_interval: 3
      }
    }
  ]);

  useEffect(() => {
    getContent();
  }, []);

  const [nextId, setNextId] = useState(2);

  const getContent = async () => {
    await fetch(`${API_URL}/api/collins/homePage/contents`).then(res => res.json().then(item => {
      const tempArr = item.contents.map((tempItem, i) => {
        return { id: i, data: tempItem, label: tempItem.order };
      });
      setIsAutoSlideEnabled(item.is_auto_slide_enabled);
      setIsRandomOrder(item.random_order);
      setItems([...tempArr]);
    }));
  };

  const saveContent = async () => {
    const data = {
      random_order: isRandomOrder,
      is_auto_slide_enabled: isAutoSlideEnabled,
      contents: items.map((item, i) => {
        item.data.order = i + 1;
        return item.data;
      })
    };
    await fetch(`${API_URL}/api/collins/homePage/contents`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(data)
    }).then(res => {
      window.alert("저장 완료되었습니다.");
    }).catch(err => {
      window.alert("저장 실패했습니다.");
    });
  };

  const moveItem = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= items.length) return;
    const newItems = [...items];
    const temp = newItems[index];
    newItems[index] = newItems[newIndex];
    newItems[newIndex] = temp;
    setItems(newItems);
  };

  const addItemToTop = () => {
    const newItem = {
      id: nextId,
      label: `섹션 ${nextId}`,
      expanded: true,
      data: {
        asset: { mobile: "", desktop: "" },
        title: { text: "", font_color: "#000000" },
        button: {
          background_color: "#000000",
          font_color: "#ffffff",
          is_outlined: false,
          outline_color: "#ffffff",
          text: "",
          link: ""
        },
        is_gradient_enabled: false,
        auto_slide_interval: 3
      }
    };
    setItems([newItem, ...items]);
    setNextId(nextId + 1);
  };

  const deleteItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const toggleExpand = (id) => {
    setItems(
      items.map((item) =>
        item.id === id ? { ...item, expanded: !item.expanded } : item
      )
    );
  };
  const updateItemField = (id, path, value) => {
    setItems((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;
        const updated = { ...item };
        let target = updated.data;
        const keys = path.split(".");
        for (let i = 0; i < keys.length - 1; i++) {
          target = target[keys[i]];
        }
        target[keys[keys.length - 1]] = value;
        return updated;
      })
    );
  };

  const handleAssetFileUpload = async (e, id, target) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      // items 상태 업데이트 (예: setItems)
      setItems((prev) =>
        prev.map((item) =>
          item.id === id
            ? {
              ...item,
              data: {
                ...item.data,
                asset: {
                  ...item.data.asset,
                  [target]: reader.result // base64 or blob URL
                }
              }
              // previewUrl도 동일하게 넣어도 됨 (선택)
            }
            : item
        )
      );
    };
    reader.readAsDataURL(file);

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileType", "img");

      const res = await fetch(`${API_URL}/api/collins/homePage/upload`, {
        method: "POST",
        body: formData,
        credentials: "include"
      });

      if (!res.ok) throw new Error("Upload failed");

      const json = await res.json();
      // 예: json.url 에 업로드된 파일 URL이 있다고 가정
      // 3. 서버 URL로 상태 업데이트
      setItems(prev =>
        prev.map(item =>
          item.id === id
            ? {
              ...item,
              data: {
                ...item.data,
                asset: {
                  ...item.data.asset,
                  [target]: json.data // 서버에서 받은 실제 URL로 교체
                }
              }
            }
            : item
        )
      );
    } catch (error) {
      console.error(error);
      // 에러처리 로직 추가 가능
    }
  };
  console.log(items);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg"
                     coloredShadow="info">
                <MDTypography variant="h6" color="white">
                  홈 최상단 섹션
                </MDTypography>
              </MDBox>
              <MDBox mx={3} mt={3} px={2}>
                <MDBox>
                  <MDBox style={{ width: "100%", display: "flex", justifyContent: "space-between" }} mb={3}>
                    <MDBox display={"flex"}>
                      <MDBox display={"flex"} mb={1} height="fit-content">
                        <MDTypography component="div" variant="caption" color="text" fontSize="16px"
                                      fontWeight="medium">
                          자동 슬라이드
                        </MDTypography>
                        <input checked={isAutoSlideEnabled} onChange={() => setIsAutoSlideEnabled(!isAutoSlideEnabled)}
                               type={"checkbox"}
                               style={{ marginLeft: "3px" }} />
                      </MDBox>
                      <MDBox display={"flex"} mb={1} ml={3} height="fit-content">
                        <MDTypography component="div" variant="caption" color="text" fontSize="16px"
                                      fontWeight="medium">
                          순서 무작위
                        </MDTypography>
                        <input checked={isRandomOrder} onChange={() => setIsRandomOrder(!isRandomOrder)}
                               type={"checkbox"}
                               style={{ marginLeft: "3px" }} />
                      </MDBox>
                    </MDBox>
                    <MDButton color="info" onClick={saveContent}>
                      저장하기
                    </MDButton>
                  </MDBox>
                  <MDBox>
                    <MDBox mb={2} display="flex" justifyContent="flex-end">
                      <MDButton color="success" onClick={addItemToTop}>
                        + 섹션 추가
                      </MDButton>
                    </MDBox>
                    {items.map((item, index) => (
                      <Card key={item.id} sx={{ mb: 2 }}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
                          <MDBox display="flex" alignItems="center">
                            <Icon
                              sx={{ cursor: "pointer", mr: 1 }}
                              onClick={() => toggleExpand(item.id)}
                            >
                              {item.expanded ? "expand_less" : "expand_more"}
                            </Icon>
                            <MDTypography variant="body1" fontWeight="medium" style={{
                              width: "300px",            /* 또는 max-width */
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }}>
                              {item.data.title.text}
                            </MDTypography>
                          </MDBox>

                          <MDBox display="flex" alignItems="center">
                            <MDButton
                              size="small"
                              color="info"
                              variant="outlined"
                              onClick={() => moveItem(index, -1)}
                              disabled={index === 0}
                              sx={{ mr: 1 }}
                            >
                              ↑
                            </MDButton>
                            <MDButton
                              size="small"
                              color="info"
                              variant="outlined"
                              onClick={() => moveItem(index, 1)}
                              disabled={index === items.length - 1}
                              sx={{ mr: 1 }}
                            >
                              ↓
                            </MDButton>
                            <MDButton
                              size="small"
                              color="error"
                              variant="outlined"
                              onClick={() => deleteItem(item.id)}
                            >
                              🗑
                            </MDButton>
                          </MDBox>
                        </MDBox>

                        {item.expanded && (
                          <MDBox px={3} pb={2} display="grid" rowGap={3}>
                            {/* Asset */}
                            <MDTypography variant="subtitle2" fontWeight="bold">📱 Asset</MDTypography>
                            <MDBox>
                              <MDBox>
                                <MDTypography variant="caption" mr={1}>Mobile (image/video) - 720*1280 이상 권장</MDTypography>
                                <input
                                  type="file"
                                  accept="image/*,video/*"
                                  onChange={(e) => handleAssetFileUpload(e, item.id, "mobile")}
                                />
                              </MDBox>
                              {item.data.asset.mobile && (
                                <>
                                  {item.data.asset.mobile.includes("mp4") ? (
                                    <video src={item.data.asset.mobile} controls width="150" />
                                  ) : (
                                    <img src={item.data.asset.mobile} alt="Mobile preview"
                                         style={{ maxWidth: 150, marginTop: 8 }} />
                                  )}
                                </>
                              )}
                            </MDBox>

                            <MDBox mb={5}>
                              <MDBox>
                                <MDTypography variant="caption" mr={1}>Desktop (image/video) - 1920*1080 이상 권장</MDTypography>
                                <input
                                  type="file"
                                  accept="image/*,video/*"
                                  onChange={(e) => handleAssetFileUpload(e, item.id, "desktop")}
                                />
                              </MDBox>
                              {item.data.asset.desktop && (
                                <>
                                  {item.data.asset.desktop.includes("mp4") ? (
                                    <video src={item.data.asset.desktop} controls width="150" />
                                  ) : (
                                    <img src={item.data.asset.desktop} alt="Desktop preview"
                                         style={{ maxWidth: 150, marginTop: 8 }} />
                                  )}
                                </>
                              )}
                            </MDBox>

                            {/* Title */}
                            <MDTypography variant="subtitle2" fontWeight="bold">📝 Title</MDTypography>
                            <TextField
                              label="Text"
                              value={item.data.title.text}
                              onChange={(e) =>
                                updateItemField(item.id, "title.text", e.target.value)
                              }
                              multiline
                              rows={4}
                              fullWidth
                            />
                            <MDBox display="flex" alignItems="center">
                              <MDTypography mr={1} style={{ fontSize: "16px" }}>Font Color</MDTypography>
                              <TextField
                                label="Hex"
                                value={item.data.title.font_color}
                                onChange={(e) =>
                                  updateItemField(item.id, "title.font_color", e.target.value)
                                }
                                size="small"
                                style={{ width: "100px" }}
                                inputProps={{ maxLength: 7 }}
                              />
                              <Box
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  backgroundColor: item.data.title.font_color,
                                  border: "1px solid #ccc",
                                  marginLeft: "5px",
                                  borderRadius: "4px"
                                }}
                              />
                            </MDBox>

                            {/* Button */}
                            <MDBox mt={4}>
                            </MDBox>
                            <MDTypography variant="subtitle2" fontWeight="bold">🔘 Button</MDTypography>
                            <TextField
                              label="Text"
                              value={item.data.button.text}
                              onChange={(e) =>
                                updateItemField(item.id, "button.text", e.target.value)
                              }
                              fullWidth
                            />
                            <TextField
                              label="Link"
                              value={item.data.button.link}
                              onChange={(e) =>
                                updateItemField(item.id, "button.link", e.target.value)
                              }
                              fullWidth
                            />
                            <MDBox display="flex" alignItems="center">
                              <MDTypography mr={1} style={{ fontSize: "16px" }}>BG Color</MDTypography>
                              <TextField
                                label="Hex"
                                value={item.data.button.background_color}
                                onChange={(e) =>
                                  updateItemField(item.id, "button.background_color", e.target.value)
                                }
                                size="small"
                                style={{ width: "100px" }}
                                inputProps={{ maxLength: 7 }}
                              />
                              <Box
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  backgroundColor: item.data.button.background_color,
                                  border: "1px solid #ccc",
                                  marginLeft: "5px",
                                  borderRadius: "4px"
                                }}
                              />
                              <MDTypography ml={3} mr={1} style={{ fontSize: "16px" }}>Font Color</MDTypography>
                              <TextField
                                label="Hex"
                                value={item.data.button.font_color}
                                onChange={(e) =>
                                  updateItemField(item.id, "button.font_color", e.target.value)
                                }
                                size="small"
                                style={{ width: "100px" }}
                                inputProps={{ maxLength: 7 }}
                              />
                              <Box
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  backgroundColor: item.data.button.font_color,
                                  border: "1px solid #ccc",
                                  marginLeft: "5px",
                                  borderRadius: "4px"
                                }}
                              />
                              <MDTypography ml={3} mr={1} style={{ fontSize: "16px" }}>Outline 유무</MDTypography>
                              <input
                                type="checkbox"
                                checked={item.data.button.is_outlined}
                                onChange={(e) =>
                                  updateItemField(item.id, "button.is_outlined", e.target.checked)
                                }
                              />
                              <MDTypography ml={3} mr={1} style={{ fontSize: "16px" }}>Outline Color</MDTypography>
                              <TextField
                                label="Hex"
                                value={item.data.button.outline_color}
                                onChange={(e) =>
                                  updateItemField(item.id, "button.outline_color", e.target.value)
                                }
                                size="small"
                                style={{ width: "100px" }}
                                inputProps={{ maxLength: "7" }}
                              />
                              <Box
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  backgroundColor: item.data.button.outline_color,
                                  border: "1px solid #ccc",
                                  marginLeft: "5px",
                                  borderRadius: "4px"
                                }}
                              />
                            </MDBox>
                            <MDBox mt={4}>
                            </MDBox>
                            <MDBox display="flex" alignItems="center">
                              <MDTypography mr={2} style={{ fontSize: "16px" }}>그라디언트 활성화</MDTypography>
                              <input
                                type="checkbox"
                                checked={item.data.is_gradient_enabled}
                                onChange={(e) =>
                                  updateItemField(item.id, "is_gradient_enabled", e.target.checked)
                                }
                              />
                            </MDBox>
                            <MDBox display="flex" alignItems="center">
                              <MDTypography mr={3} style={{ fontSize: "16px" }}>자동 슬라이드 간격 (초)</MDTypography>
                              <TextField
                                label="자동 슬라이드 간격 (초)"
                                type="number"
                                style={{ maxWidth: "200px" }}
                                value={item.data.auto_slide_interval}
                                onChange={(e) =>
                                  updateItemField(item.id, "auto_slide_interval", Number(e.target.value))
                                }
                                fullWidth
                              />
                            </MDBox>
                          </MDBox>
                        )}
                      </Card>
                    ))}
                  </MDBox>

                </MDBox>
              </MDBox>
            </Card>

          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default HomeSectionEditor;
